import cn from 'classnames';
import React from 'react';
import Typography from '~components/typography';

export type ButtonStatus =
  | 'success'
  | 'pending'
  | 'todo'
  | 'complete'
  | 'error'
  | 'warning'
  | 'grey'
  | 'awaiting'
  | 'black';

interface IStatusButtonProps {
  name?: string;
  status: ButtonStatus;
}
const StatusButton: React.FC<IStatusButtonProps & React.HTMLAttributes<HTMLDivElement>> = props => {
  const { name, status, style } = props;
  let nameColor = '';
  if (status === 'success') {
    nameColor = 'var(--color-green_7)';
  } else if (status === 'pending') {
    nameColor = 'var(--color-yellow_6)';
  } else if (status === 'todo') {
    nameColor = 'var(--color-red_6)';
  } else if (status === 'grey') {
    nameColor = 'var(--color-grey_99)';
  } else {
    nameColor = 'var(--color-white)';
  }
  return (
    <div
      className={cn('status-button', `status-button--${status}`, props.className)}
      style={{ ...style }}
    >
      <Typography component="div" variant="meta" className="status-button__name" color={nameColor}>
        {name}
      </Typography>
      <style jsx>
        {`
          .status-button {
            display: inline-block;
            padding: 2px 12px;
            height: 24px;
            text-align: center;
            border-radius: 12px;
            &--success {
              background-color: var(--color-green_1);
            }
            &--pending {
              background-color: var(--color-yellow_1);
            }
            &--todo {
              background-color: var(--color-red_1);
            }
            &--complete {
              background-color: var(--color-green_6);
            }
            &--error {
              background-color: var(--color-red_6);
            }
            &--warning {
              background-color: var(--color-yellow_6);
            }
            &--grey {
              background-color: var(--color-greyEb);
            }
            &--black {
              background-color: var(--color-grey_99);
            }
            &--awaiting {
              background-color: var(--color-yellow_8);
            }
            :global(&__name) {
              line-height: 20px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default StatusButton;
